import React from "react";
import { Navigate } from "react-router-dom";
import Dashboard from "../../components/Dashboard";

const ProtectedRoutes = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("loginData");
  // const isAuthenticated = true;
  return isAuthenticated ? (
    <Dashboard children={children} />
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoutes;
